import React from 'react';
import { Button } from './ui/button';
import { Mail, MapPin, ArrowRight } from 'lucide-react';
import { personalInfo } from '../data/mock';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center bg-gradient-to-b from-gray-50 to-white pt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-gray-900 leading-tight">
                {personalInfo.name}
              </h1>
              <h2 className="text-2xl md:text-3xl text-gray-700 font-medium">
                {personalInfo.title}
              </h2>
              <p className="text-xl text-gray-600 font-light">
                {personalInfo.tagline}
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 text-gray-600">
              <div className="flex items-center gap-2">
                <MapPin className="w-5 h-5" />
                <span>{personalInfo.location}</span>
              </div>
              <div className="flex items-center gap-2">
                <Mail className="w-5 h-5" />
                <span>{personalInfo.email}</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button
                onClick={() => scrollToSection('contact')}
                className="bg-gray-900 hover:bg-gray-800 text-white px-8 py-6 text-lg transition-all duration-200 hover:shadow-lg"
              >
                Let's Work Together
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
              <Button
                onClick={() => scrollToSection('case-studies')}
                variant="outline"
                className="border-2 border-gray-900 text-gray-900 hover:bg-gray-900 hover:text-white px-8 py-6 text-lg transition-all duration-200"
              >
                View Case Studies
              </Button>
            </div>
          </div>

          {/* Right Content - Professional Image */}
          <div className="flex justify-center lg:justify-end">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-gray-200 to-gray-300 rounded-2xl transform rotate-3"></div>
              <img
                src={personalInfo.headshot}
                alt={personalInfo.name}
                className="relative w-full max-w-md h-auto rounded-2xl shadow-2xl object-cover"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-gray-900 rounded-full flex justify-center">
          <div className="w-1 h-3 bg-gray-900 rounded-full mt-2"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;